// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!../assets/fonts/PTRootUi/PTRootUI.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  box-sizing: border-box;
  font-size: 15px;
}

* {
  scrollbar-width: thin;
}

*,
*:before,
*:after {
  box-sizing: inherit;
}

*::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}

*::-webkit-scrollbar-thumb {
  background-color: #979797;
  border-radius: 10px;
}

body {
  /*min-width: 1280px;*/
  font-family: 'PT Root UI';
  font-size: 16px;
  -webkit-text-size-adjust: 100%;
  margin: 0;
  background-color: #fff;
  --appbar-height: 48px;
  --appbar-height-mobile: 32px;
  --footer-height: 32px;
}

div#root {
  width: 100%;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.public-page {
  background: #f7f7f7;
  height: 100vh;
}

.footer {
  text-align: center;
  padding: 8px;
  height: var(--footer-height);
  background: #b2b2b2;
}

.pointer {
  cursor: pointer;
}

.opacity50 {
  opacity: 50%;
}

.mr-8 {
  margin-right: 8px;
}

.ml-8 {
  margin-left: 8px;
}

.MuiPickersPopper-root {
  @media screen and (max-width: 608px) {
    left: calc(50% - 320px / 2) !important;
    top: calc(50% - 334px / 2) !important;
    transform: none !important;
  }
}

.mapPositionRange {
  -webkit-appearance: none;
  appearance: none;
  transform: rotate(-90deg);
  width: 100px;
  height: 8px;
  background: #989898;
  border-radius: 4px;
}

.mapPositionRange::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 12px;
  height: 16px;
  cursor: default;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0px 0px 4px 1px rgba(34, 60, 80, 0.2);
}

.mapboxgl-ctrl {
  display: flex;
  flex-direction: column;
  height: 160px;
  justify-content: space-between;
}

.pointerIcon {
  z-index: 1;
  /* animation: stick 0.3s ease; */
  pointer-events: none;
}

.pointerIconHidden {
  opacity: 0;
  pointer-events: none;
}

@keyframes stick {
  0% {
    opacity: 0;
  }

  90% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/styles.css"],"names":[],"mappings":"AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;EACf,8BAA8B;EAC9B,SAAS;EACT,sBAAsB;EACtB,qBAAqB;EACrB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,sCAAsC;IACtC,qCAAqC;IACrC,0BAA0B;EAC5B;AACF;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF","sourcesContent":["@import url('../assets/fonts/PTRootUi/PTRootUI.css');\r\n\r\nhtml {\r\n  box-sizing: border-box;\r\n  font-size: 15px;\r\n}\r\n\r\n* {\r\n  scrollbar-width: thin;\r\n}\r\n\r\n*,\r\n*:before,\r\n*:after {\r\n  box-sizing: inherit;\r\n}\r\n\r\n*::-webkit-scrollbar {\r\n  width: 4px;\r\n  height: 4px;\r\n}\r\n\r\n*::-webkit-scrollbar-thumb {\r\n  background-color: #979797;\r\n  border-radius: 10px;\r\n}\r\n\r\nbody {\r\n  /*min-width: 1280px;*/\r\n  font-family: 'PT Root UI';\r\n  font-size: 16px;\r\n  -webkit-text-size-adjust: 100%;\r\n  margin: 0;\r\n  background-color: #fff;\r\n  --appbar-height: 48px;\r\n  --appbar-height-mobile: 32px;\r\n  --footer-height: 32px;\r\n}\r\n\r\ndiv#root {\r\n  width: 100%;\r\n  margin: 0;\r\n  padding: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 100vh;\r\n}\r\n\r\n.public-page {\r\n  background: #f7f7f7;\r\n  height: 100vh;\r\n}\r\n\r\n.footer {\r\n  text-align: center;\r\n  padding: 8px;\r\n  height: var(--footer-height);\r\n  background: #b2b2b2;\r\n}\r\n\r\n.pointer {\r\n  cursor: pointer;\r\n}\r\n\r\n.opacity50 {\r\n  opacity: 50%;\r\n}\r\n\r\n.mr-8 {\r\n  margin-right: 8px;\r\n}\r\n\r\n.ml-8 {\r\n  margin-left: 8px;\r\n}\r\n\r\n.MuiPickersPopper-root {\r\n  @media screen and (max-width: 608px) {\r\n    left: calc(50% - 320px / 2) !important;\r\n    top: calc(50% - 334px / 2) !important;\r\n    transform: none !important;\r\n  }\r\n}\r\n\r\n.mapPositionRange {\r\n  -webkit-appearance: none;\r\n  appearance: none;\r\n  transform: rotate(-90deg);\r\n  width: 100px;\r\n  height: 8px;\r\n  background: #989898;\r\n  border-radius: 4px;\r\n}\r\n\r\n.mapPositionRange::-webkit-slider-thumb {\r\n  -webkit-appearance: none;\r\n  appearance: none;\r\n  width: 12px;\r\n  height: 16px;\r\n  cursor: default;\r\n  background: #fff;\r\n  border-radius: 10px;\r\n  box-shadow: 0px 0px 4px 1px rgba(34, 60, 80, 0.2);\r\n}\r\n\r\n.mapboxgl-ctrl {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 160px;\r\n  justify-content: space-between;\r\n}\r\n\r\n.pointerIcon {\r\n  z-index: 1;\r\n  /* animation: stick 0.3s ease; */\r\n  pointer-events: none;\r\n}\r\n\r\n.pointerIconHidden {\r\n  opacity: 0;\r\n  pointer-events: none;\r\n}\r\n\r\n@keyframes stick {\r\n  0% {\r\n    opacity: 0;\r\n  }\r\n\r\n  90% {\r\n    opacity: 0;\r\n  }\r\n\r\n  100% {\r\n    opacity: 1;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
